const vowels = {
	a: 'a',
	e: 'e',
	i: 'i',
	o: 'o',
	u: 'u',
	y: 'y',
};

export const tags = {
	// tags
	...vowels,
	emailConfirmed: 'email.confirmed',
	customer: 'customer', // added after first purchase in the app
	subscriber: 'subscriber', // ever had a subscription
	subscription: 'subscription',
	// experiments
	newPaywall: 'ai.subscription.paywall',
	emailConfirmRequired: 'ai.confirmation.wall',
	isSafe: 'isSafe',
	test: 'test',
	neuronsWithPricePer100: 'ai.web.price.per.100.neurons.paywall.exp',
	suggestedTexts: 'ai.suggestions',
};
